/* eslint-disable react-hooks/exhaustive-deps */
import { useAsync } from "@corets/use-async"
import { useForm } from "@corets/use-form"
import { ChangeEvent, KeyboardEvent, useEffect } from "react"
import { useHistory } from "react-router"
import { WPlus } from "../../../../../assets/images"
import { links } from "../../../../../config/links"
import { Select } from "../../../../oneportal/components/Select"
import { createMuiFormBinder } from "../../../../oneportal/helpers/createMuiFormBinder"
import { useApiClient } from "../../../../oneportal/hooks/useApiClient"
import { getLookupReflectionProcessingUnit } from "../../../../oneportal/services/api/administrative"
import { createSearchUserForm, SearchUserFormType } from "./createSearchUserForm"

export type SearchUserFormProps = {
  onSubmit: (data: SearchUserFormType) => void
  defaultValue: SearchUserFormType
  setShowModalCreate: (open: boolean) => void
}
export const SearchUserForm = (props: SearchUserFormProps) => {
  const { onSubmit, defaultValue, setShowModalCreate } = props
  const history = useHistory()
  const api = useApiClient()

  const [form] = useForm(createSearchUserForm(defaultValue), [defaultValue])
  const bind = createMuiFormBinder(form)
  const reflectionProcessingUnitOptions = useAsync(() => getLookupReflectionProcessingUnit(api), [])

  const handleSubmit = async () => {
    const data = await form.get()
    onSubmit(data)
  }

  const handleChangeFormValue = (event: ChangeEvent<HTMLInputElement>, field: string) => {
    const value = event.target.value
    form.setAt(field, value)
    if (!value) {
      handleSubmit()
    }
  }

  const handleKeyEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit()
    }
  }

  useEffect(() => {
    if (form.getAt("processingUnitId")) {
      handleSubmit()
    }
  }, [form.getAt("processingUnitId")])

  return (
    <form>
      <div className="form-row flex-wrap">
        <div className="form-group mb-0 col-lg-4">
          <input
            value={form.getAt("email") || ""}
            onChange={(event) => handleChangeFormValue(event, "email")}
            className="form-control"
            placeholder="Tìm theo email"
            onKeyDown={handleKeyEnter}
          />
        </div>
        <div className="form-group mb-0 col-lg-4">
          <Select
            options={reflectionProcessingUnitOptions.getResult()?.content}
            bind={bind}
            field={"processingUnitId"}
            labelDefaultOption="Chọn đơn vị"
          />
        </div>
        <div className="form__save-ct">
          <div className="form__save border-top-0 pt-0 mt-0 justify-content-start">
            <button className="btn btn-ct btn-primary-ct" type="button" onClick={handleSubmit}>
              Tìm kiếm
            </button>
            <button
              className="btn  btn-ct  btn-add btn-danger-ct  d-flex align-items-center"
              type="button"
              onClick={() => setShowModalCreate(true)}
            >
              Thêm user
              <img src={WPlus} alt="" />
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}
